import { type FC } from 'react'

import { type OfferV11 } from '@redteclab/api/clients/bully'

import { productAccessorGetBestSellerPromotionFromOffer } from '../../../../../product'
import { useProductPageContext } from '../../../productPageContext'
import { ProductBuyBoxSellerPromotionBadge } from '../../ProductBuyBoxSellerPromotionBadge/ProductBuyBoxSellerPromotionBadge'

type ProductOfferCardSellerPromotionLabelProps = {
  offer: OfferV11
}

export const ProductOfferCardSellerPromotionLabel: FC<
  ProductOfferCardSellerPromotionLabelProps
> = ({ offer }) => {
  const sellerPromotion = productAccessorGetBestSellerPromotionFromOffer(offer)
  const { product } = useProductPageContext()

  if (!sellerPromotion) {
    return null
  }

  return (
    <ProductBuyBoxSellerPromotionBadge
      offer={offer}
      product={product}
      sellerPromotion={sellerPromotion}
    />
  )
}
